import React, { createContext, useContext, useReducer } from "react";

// Create data layer
export const StateContext = createContext();

// Wrap the app and provide the data layer
export const StateProvider = ({ reducer, initialState, children }) => {
  return (
    <StateContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </StateContext.Provider>
  );
};

// Hook to pull data from the data layer
export const useStateValue = () => useContext(StateContext);
